// Small presentational components for loading / error / empty states.

export function Loading({ label = 'Loading…' }) {
  return (
    <div className="state state--loading">
      <span className="spinner" />
      <span>{label}</span>
    </div>
  );
}

export function ErrorState({ error, onRetry }) {
  return (
    <div className="state state--error">
      <div className="state__title">Something went wrong</div>
      <div className="state__detail">{error?.message || 'Unknown error'}</div>
      {onRetry ? (
        <button className="btn btn--ghost" onClick={onRetry}>
          Retry
        </button>
      ) : null}
    </div>
  );
}

export function EmptyState({ title = 'Nothing here yet', detail, action }) {
  return (
    <div className="state state--empty">
      <div className="state__title">{title}</div>
      {detail ? <div className="state__detail">{detail}</div> : null}
      {action}
    </div>
  );
}
